import trekronorTheme from "../../trekronorTheme";
export default {
  ...trekronorTheme,
  colors: {
    ...trekronorTheme.colors,
    link: trekronorTheme.colors.primary2,
    linkHover: trekronorTheme.colors.primary1
  },
  fonts: {
    ...trekronorTheme.fonts,
    serif: trekronorTheme.fonts.sans
  }
};
